import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ENDPOINTS } from '../constants/app-values';
import { AppStorage } from './appStorage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  API_URL = 'http://10.0.4.21:60549';
  API_URL_LOGIN = ENDPOINTS.HOST + '/login';
  API_URL_DATOS_SESION = ENDPOINTS.HOST + '/usuario';

  mock = {
    perfil: 'Test',
    token: '12341234asdfadsf'
  };

  login(user, pass, token_captcha) {
    const body = {
      usuario: user,
      contrasena: pass,
      token: token_captcha
    };

    return this.httpClient
      .post(this.API_URL_LOGIN, body, { observe: 'response' })
      .toPromise();
  }

  loginCognito(token, expires) {
    const body = {
      usuario: '',
      contrasena: '',
      token: token,
      expire: expires
    };
    return this.httpClient
      .post(this.API_URL_LOGIN, body, {observe: 'response'})
      .toPromise();
  }

  getDatosSesion() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    return this.httpClient.get(this.API_URL_DATOS_SESION, {headers: headers}).toPromise();
  }
}
